import { ArticoliMatricola } from './articoli-matricola';

export class MovimentiMagazzino {
  id: number;
  data: Date;
  idArticolo: number;
  idCausale: number;
  qta: number;
  qtaRealValue: number;
  utenteStr: string;
  note: string;
  idArticoloMatricola: number;
}

export class PostMovimentiMagazzinoMatricola {
  movimentoMagazzino: MovimentiMagazzino;
  listArticoliMatricola: ArticoliMatricola[];
}